// src/components/layout/PalliumPageBackground.js
import React from 'react';

/**
 * PalliumPageBackground - Full-page background component with dark navy overlay
 * 
 * Used for authentication pages and full-page layouts that need the branded
 * Pallium background treatment.
 * 
 * @param {Object} props
 * @param {React.ReactNode} props.children - Content to render inside the background
 * @param {boolean} props.centered - Whether to center content vertically and horizontally (default: true)
 */
const PalliumPageBackground = ({ children, centered = true }) => {
    return (
        <div 
            className="min-h-screen relative"
            style={{ 
                background: 'var(--pallium-gradient-dark)',
            }}
        >
            {/* Dark navy overlay */}
            <div 
                className="absolute inset-0 pointer-events-none" 
                style={{ 
                    backgroundColor: 'var(--pallium-primary-dark-navy)', 
                    opacity: 0.3 
                }} 
            />
            {/* Content wrapper */}
            <div 
                className={`relative z-10 ${centered ? 'min-h-screen flex items-center justify-center p-4' : ''}`}
            >
                {children}
            </div>
        </div>
    );
};

export default PalliumPageBackground;

